export function loading() {
  $(window).on('load',function(){
    $(".p-loading").delay(3000).fadeOut('slow');//ローディング画面を3秒（3000ms）待機してからフェイドアウト
    $('.p-loading_text').addClass('is-animated');
  });
}